export default {
  //保存
  SAVE: '/jcnapi/system/save',
  //保存
  GET: '/jcnapi/system/get'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/platform/index.js